import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as data from '../../../utils/data';

class RTWSummaryItemForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onAdd: PropTypes.func,
	};

	schema = {
		rtPartNumber: Joi.string().required().label('RT Part Number'),
		artifacts: Joi.string().required().label('Artifacts'),
		discontinuities: Joi.string().required().label('Discontinuities'),
		discontinuitiesLength: Joi.number()
			.required()
			.label('Discontinuities Length (mm)'),
		discontinuitiesType: Joi.string().required().label('Discontinuities Type'),
		defect: Joi.string().required().label('Defect'),
		defectType: Joi.string().required().label('Defect Type'),
		defectLength: Joi.number().required().label('Defect Length (mm)'),
		pipeDiameter: Joi.number().required().label('Diameter of Pipe (inches)'),
		schedule: Joi.string().required().label('Schedule'),
		pipeSpec: Joi.string().required().label('Pipe Specification'),
		drtResult: Joi.string().required().label('DRT Result'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onAdd(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'rtPartNumber',
							label: 'RT Part Number',
							placeholder: 'Enter RT Part Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'artifacts',
							label: 'Artifacts',
							placeholder: 'Enter Artifacts',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'discontinuities',
							label: 'Discontinuities',
							placeholder: 'Discontinuities',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'discontinuitiesLength',
							label: 'Discontinuities Length (mm)',
							placeholder: 'Enter Discontinuities Length (mm)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'discontinuitiesType',
							label: 'Discontinuities Type',
							placeholder: 'Enter Discontinuities Type',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'defect',
							label: 'Defect',
							placeholder: 'Enter Defect',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'defectType',
							label: 'Defect Type',
							placeholder: 'Enter Defect Type',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'defectLength',
							label: 'Defect Length (mm)',
							placeholder: 'Enter Defect Length (mm)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'pipeDiameter',
							label: 'Diameter of Pipe (inches)',
							placeholder: 'Enter Diameter of Pipe (inches)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'schedule',
							label: 'Schedule',
							placeholder: 'Enter Schedule',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'pipeSpec',
							label: 'Pipe Specification',
							placeholder: 'Enter Pipe Specification',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'drtResult',
							label: 'DRT Result',
							placeholder: 'Select DRT Result',
							options: data.getResultOptions(),
						})}
					</div>
				</div>
				<div className="d-flex justify-content-end">
					{this.renderButton('Add Row')}
				</div>
			</form>
		);
	}
}

const initialData = {
	rtPartNumber: '',
	artifacts: '',
	discontinuities: '',
	discontinuitiesLength: '',
	discontinuitiesType: '',
	defect: '',
	defectType: '',
	defectLength: '',
	pipeDiameter: '',
	schedule: '',
	pipeSpec: '',
	drtResult: '',
};

export default RTWSummaryItemForm;
